import SingleProductFilteringTable from './SingleProductFilteringTable'

export default SingleProductFilteringTable
